import { render, staticRenderFns } from "./weikaipiaoSR.vue?vue&type=template&id=38f66ff7&scoped=true&"
import script from "./weikaipiaoSR.vue?vue&type=script&lang=js&"
export * from "./weikaipiaoSR.vue?vue&type=script&lang=js&"
import style0 from "./weikaipiaoSR.vue?vue&type=style&index=0&id=38f66ff7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f66ff7",
  null
  
)

export default component.exports